import useAuth from './useAuth'
import type { Permission } from '../types/permissions'

const usePermissions = (): { can: (permission: Permission) => boolean; canWrite: (resource: string) => boolean } => {
  const { user, hasPermission } = useAuth()

  const can = (permission: Permission): boolean => {
    if (!user) return false
    return hasPermission(permission)
  }

  // Returns true if the user has any write-level permission (create, update, or delete) on the resource
  const canWrite = (resource: string): boolean => {
    if (!user) return false
    return (
      hasPermission(`${resource}:create` as Permission) ||
      hasPermission(`${resource}:update` as Permission) ||
      hasPermission(`${resource}:delete` as Permission)
    )
  }

  return { can, canWrite }
}

export default usePermissions
